import gql from 'graphql-tag';

export const getCaptcha = gql`
  query getCaptcha {
    getCaptcha {
      cookies
      imageCaptcha
    }
  }
`;
export const RegisterInsuranceValidation = gql`
  mutation RegisterInsuranceValidation(
    $isAutomated: Boolean!
    $attachedFiles: [AttachedFile!]!
    $ddjjInsuranceValidity: Boolean!
    $ddjjSusaludDoc: Boolean!
    $period: String!
    $campus: String!
  ) {
    registerInsuranceValidation(
      isAutomated: $isAutomated
      attachedFiles: $attachedFiles
      ddjjInsuranceValidity: $ddjjInsuranceValidity
      ddjjSusaludDoc: $ddjjSusaludDoc
      period: $period
      campus: $campus
    ) {
      state
      idProcedure
      codePSE
      FlagError
    }
  }
`;
